export default "__VITE_ASSET__CYxU6SeG__"